import { Stack as MuiStack, Typography as MuiTypography } from "@mui/material";
import { useTranslation } from "react-i18next";
import StudyRecruitmentContainer from "./StudyRecruitmentContainer";

const StudyRecruitmentPage = () => {
  const { t } = useTranslation();

  return (
    <MuiStack
      gap={2}
      sx={{ backgroundColor: "#f0f4f5", flexGrow: 1, padding: "30px 0" }}
    >
      <MuiStack mx="auto" width="1146px" gap={2}>
        <MuiTypography variant="h1" fontWeight={500}>
          {t("studyRecruitment.title")}
        </MuiTypography>
        <StudyRecruitmentContainer />
      </MuiStack>
    </MuiStack>
  );
};

export default StudyRecruitmentPage;
